export default class Page {
  constructor(data, Model) {
    const meta = data.meta;

    this.currentPage = meta.current_page;
    this.from = meta.from;
    this.to = meta.to;
    this.lastPage = meta.last_page;
    this.perPage = meta.per_page;
    this.total = meta.total;

    this.items = data.data.map(item => new Model(item));
  }
}
